import type { Page, TruckListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../components/EmptyState';
import { ListSearch } from '../../components/ListSearch';
import type { ListQueryControls } from '../../lib/use-list-query';
import type { TruckListItem } from './trucks.api';

interface TrucksTableProps {
  page: Page<TruckListItem>;
  columns: TableColumnsType<TruckListItem>;
  list: ListQueryControls<TruckListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function TrucksTable({ page, columns, list, isRefreshing }: TrucksTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search registration, make or model" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingTrucks /> } : undefined}
        {...list.tableProps<TruckListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingTrucks() {
  return <EmptyState icon={SearchX} title="No matching trucks" description="No trucks match this search or these filters." />;
}
